import {
  Component,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  Inject,
} from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
// ngrx store
import { Store } from "@ngrx/store";
import { interval, Subscription } from "rxjs";
// services
import { LoginService } from "../../services/login.service";
import { DataStorageService } from "../../services/data-storage.service";
import { CopyService } from "../../../shared/services/app-copy.service";
import { ErrorHandler } from "../../../shared/services/error-handler.service";
// models
import { AppState } from "../../../booking/models/app-state.interface";
import { map, take, takeWhile } from "rxjs/operators";
// globals
import { EMAIL_PATTERN } from '../../../shared/globals';

declare var exponea: any;

@Component({
  selector: "app-login-otp",
  templateUrl: "./login-otp.component.html",
  styleUrls: ["./login-otp.component.scss"],
})
export class LoginOtpComponent implements OnInit, OnDestroy {
  private _userSubscription: Subscription;
  private _tokenSubscription: Subscription;
  private _dataLoadedSubscription: Subscription;
  private _userStoreSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;
  private _validateOTPCodeSubscription: Subscription;
  private _resetPasswordsubscription: Subscription;
  private _routeParamsSubscription: Subscription;

  private _userRedirect: any;

  public parentRoute = "";
  public showLoader: Boolean = false;
  public emailPattern = EMAIL_PATTERN;
  public userEmail: string;
  public rememberMe = true;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = "";

  public showEmailSent: Boolean = false;
  public countdown = 1;
  public isCounting: boolean = false;
  public is2FARequired: boolean = false;
  public userToken: string;
  public channel: 'Sms' | 'Whatsapp' = 'Sms';

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _dataStorage: DataStorageService,
    private _copyService: CopyService,
    private _errorHandler: ErrorHandler,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    this._userLanguageSubscription = this._appStore
      .select("copyReducer")
      .subscribe((res: any) => {
        this.selectedLanguage = res.language;
      });

    if (isPlatformBrowser(this.platformId)) {

      this._bookingInitSubscription = this._appStore
        .select("loadedStatusReducer")
        .subscribe((res: any) => {
          this.copyLoaded = res.copyLoaded;
          if (res.copyLoaded) {
            this.getCopy();
          }
        });
      // get url - check if login is in modal
      const urlFrag = window.location.pathname.split("/");
      const urlFragLength = urlFrag.length - 1;
      this.parentRoute = urlFrag[urlFragLength];
      this.startCountDown();
      debugger;

      const data = {
        text: "OTP sent to Email!",
        type: "info",
      };
      if (this.getState(this._appStore).userReducer.userDetails.is2FARequired) {
        data.text = 'OTP sent to phone number!';
      }
      this._errorHandler.handleCustomInfo(data);
    }

    this._routeParamsSubscription = this._activatedRoute.queryParams.subscribe(
      (params: any) => {
        if (params.emailSent === "true") {
          this.showEmailSent = true;
        }
      },
      (err) => console.log(err)
    );

    this._userStoreSubscription = this._appStore
      .select("userReducer")
      .subscribe((user: any) => {
        if (user.userDetails.userEmail === '') {
          this._router.navigate(['login']);
        }

        this.is2FARequired = user.userDetails.is2FARequired;
        this.userEmail = user.userDetails.userEmail;
        this._userRedirect = user.userDetails.redirect;
        this.userToken = user.userDetails.userToken;

      });

    this._tokenSubscription = this._loginService.tokenSubject$.subscribe(
      (token) => {
        if (token.error) {
          this.handleErrors();
          this.showLoader = false;
        }
      },
      (err) => console.log(err)
    );

    this._userSubscription = this._loginService.userSubject$.subscribe(
      (user) => {
        if (user.error) {
          this.handleErrors();
        }

        if (this.parentRoute === "payment") {
          if (isPlatformBrowser(this.platformId)) {
            // login in modal
            this.showLoader = false;
            // this._modalComponent.closeModal();
            const btn = document.getElementById("login-modal-close");
            btn.click();
            return;
          }
        } else {
          // handle other login flows
          this._dataStorage.saveData();

          this._dataLoadedSubscription = this._dataStorage.dataSaved$.subscribe(
            (dataLoaded) => {
              if (this._userRedirect.path === "") {
                this._router.navigate(["my-account/home"]);
              } else {
                this._router.navigate([this._userRedirect.path], {
                  queryParams: { ref: this._userRedirect.ref },
                });
              }

              this._dataLoadedSubscription.unsubscribe();
              this.showLoader = false;
            }
          );
        }
      },
      (err) => console.log(err)
    );

    this._validateOTPCodeSubscription =
      this._loginService.validateOTPCode$.subscribe(
        (res) => {
          if (res.error) {
            this.showLoader = false;
          }
        },
        (err) => console.log(err)
      );

    this._resetPasswordsubscription =
      this._loginService.forgotPasswordEmailSent$.subscribe(
        (emailSent) => {
          if (emailSent.error) {
            this.showLoader = false;
            return;
          }

          if (emailSent) {
            const data = {
              text: "OTP sent to Email!",
              type: "info",
            };
            if (this.getState(this._appStore).userReducer.userDetails.is2FARequired) {
              data.text = 'OTP sent to phone number!';
            }
            this._errorHandler.handleCustomInfo(data);
          }

          this.showLoader = false;
          this.showEmailSent = emailSent;
          this.startCountDown();
        },
        (err) => console.log(err)
      );
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      "OTHER",
      "login",
      ["completeOTPloginScreen"]
    );
    console.log(panelHeaderCopy);
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };
  }

  handleErrors() {
    this.showLoader = false;
  }

  startCountDown() {
    if (this.isCounting) return; // Prevent multiple intervals
    this.isCounting = true;
    this.countdown = 60;

    interval(1000) // Emit every second
      .pipe(
        takeWhile(() => this.countdown > 1), // Stop when countdown reaches 1
        map(() => --this.countdown) // Decrease countdown by 1
      )
      .subscribe({
        complete: () => {
          this.isCounting = false; // Reset state after countdown ends
          this.countdown = 1; // Ensure countdown ends at 0
        },
      });
  }

  handleSubmitOTP(value, e: Event) {
    e.preventDefault();

    this.showLoader = true;
    this._loginService.validateOTPCode(value.otp, this.userEmail, 'mmb-login', this.is2FARequired);
    exponea.identify({ email_id: value.email });
    exponea.track('mmb_login', {
      login_type: 'OTP',
    });
  }

  resendEmail(e) {
    e.preventDefault();
    this.showEmailSent = false;
    if(this.is2FARequired) {
      this._loginService.SendOneTimeLoginCode(this.userEmail, 'mmb-login', this.userToken, this.channel);
    } else {
      this._loginService.sendOTP(this.userEmail);
    }
  }

  toggleChannel(e: Event) {
    e.preventDefault();
    this.showEmailSent = false;
    this.channel = this.channel === 'Sms' ? 'Whatsapp' : 'Sms';
    this._loginService.SendOneTimeLoginCode(this.userEmail, 'mmb-login', this.userToken, this.channel);
  }

  goToRegister() {
    this._router.navigate(["register"]);
  }

  goToForgotPassword() {
    this._router.navigate(["forgot-password"]);
  }

  getState(store: Store<AppState>) {
    let state: AppState;
    store.pipe(take(1)).subscribe((s) => (state = s));
    return state;
  }

  ngOnDestroy() {
    this._routeParamsSubscription.unsubscribe();
    this._resetPasswordsubscription.unsubscribe();
    this._validateOTPCodeSubscription.unsubscribe();
    this._userStoreSubscription.unsubscribe();
    this._userSubscription.unsubscribe();
    this._tokenSubscription.unsubscribe();
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }
    if (this._bookingInitSubscription) { this._bookingInitSubscription.unsubscribe(); }
  }
}
